<template>
  <div @contextmenu="handleRightClick">
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />
    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    <div class="w-[90%] mx-auto mt-2">
      <!-- <router-link
        :to="{ name: 'AdminCoursess' }"
        class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl"
      >
        Back
      </router-link> -->
      <button
        @click="$router.go(-1)"
        class="cursor-pointer bg-blues text-white hover:bg-[#18469d] hover:text-white px-3 py-1 text-sm font-bold rounded-2xl"
      >
        Back
      </button>
    </div>

    <div class="flex" v-if="!isLessonTab">
      <!-- <SideBar /> -->
      <div
        class="w-[90%] mx-auto mt-10 mb-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div v-if="loading" class="flex items-center justify-center heightfix">
          <img src="@/assets/newd/loading.gif" alt="Loading..." />
        </div>
        <div
          class="p-5 lg:p-10 flex flex-col gap-10"
          v-else-if="courseDetailInfo && courseDetailInfo.length > 0"
        >
          <div class="flex flex-col lg:flex-row items-start gap-10">
            <div class="w-full lg:w-[50%]">
              <video
                v-if="courseDetailInfo[0]?.video_url"
                :src="fixUrl(courseDetailInfo[0].video_url)"
                class="rounded-2xl h-[300px] object-cover w-full"
                controls
                playsinline
                @play="onVideo"
                @timeupdate="onVideo"
              ></video>
              <img
                v-else-if="courseDetailInfo[0].thumbnail"
                :src="courseDetailInfo[0].thumbnail"
                class="rounded-2xl h-[300px] object-cover w-full"
              />
            </div>

            <div class="flex flex-col gap-3 lg:w-[50%] mt-10 w-full">
              <h1 class="text-xl lg:text-3xl text-primary font-bold">
                {{ courseDetailInfo[0].title }}
              </h1>

              <div class="flex items-center gap-10">
                <div class="flex items-center rounded-2xl py-3 gap-2">
                  <img src="@/assets/new/rounded.png" alt="" />
                  <p class="text-xs font-bold">
                    {{ courseDetailInfo[0].sections.length }} Modules
                  </p>
                </div>
                <!-- <div class="flex items-center rounded-2xl py-3 gap-2">
                  <img src="@/assets/new/time.png" alt="" />
                  <p class="text-xs">18h 20m Left</p>
                </div> -->
                <div
                  class="flex items-center rounded-2xl py-3 gap-2"
                  v-if="courseDetailInfo[0].total_contact_hours"
                >
                  <img src="@/assets/new/time.png" alt="" />
                  <p class="text-xs font-bold">
                    {{ courseDetailInfo[0].total_contact_hours }} hours
                  </p>
                </div>
              </div>

              <div>
                <!-- Show loading only while fetching -->
                <button
                  v-if="isLessonLoading"
                  class="text-gray-400 font-semibold rounded-full py-2 text-xs"
                  disabled
                >
                  Loading...
                </button>

                <!-- Show Continue Learning if lessons exist -->
                <button
                  v-else-if="
                    lessonInfo &&
                    lessonInfo.results &&
                    lessonInfo.results.length
                  "
                  class="bg-blues text-white font-semibold rounded-full py-2 px-5 text-xs"
                  @click="
                    setUrlTap(
                      lessonInfo.results[0].video_url,
                      0,
                      lessonInfo.results[0],
                    )
                  "
                >
                  Continue Learning
                </button>

                <!-- Otherwise show No Lessons -->
                <button
                  v-else
                  class="text-blues font-semibold rounded-full py-2 text-xs"
                >
                  No Lessons
                </button>
              </div>

              <div class="flex items-center justify-between w-full hidden">
                <div>
                  <p
                    class="text-sm"
                    v-if="percentage.completion_percentage < 100"
                  >
                    In progress
                  </p>
                  <p v-else class="text-sm">Complete</p>
                </div>
                <div>
                  <p class="text-sm">{{ percentage.completion_percentage }}%</p>
                </div>
              </div>

              <div class="relative w-full bg-gray-200 rounded-full h-4 hidden">
                <div
                  class="absolute left-0 top-0 h-4 bg-blues rounded-full transition-all duration-300"
                  :style="{ width: percentage.completion_percentage + '%' }"
                ></div>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-4 px-2 hidden">
            <table class="mt-6 w-full">
              <tbody>
                <tr>
                  <th style="text-align: left !important">Course Title</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].title }}
                  </td>
                  <th style="text-align: left !important">Semester</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].semester.semester }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important">Course Code</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].course_code }}
                  </td>
                  <th style="text-align: left !important">CIE</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].cie }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important">
                    Total No. of Contact Hours
                  </th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].total_contact_hours }}
                  </td>
                  <th style="text-align: left !important">SEE</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].see }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important">
                    No. of Contact Hours/Week
                  </th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].no_of_contact_hours }}
                  </td>
                  <th style="text-align: left !important">Total</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].total }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important">Credits</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].credits }}
                  </td>
                  <th style="text-align: left !important">Exam. Duration</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].exam_duration }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important" colspan="1">
                    Teaching Dept
                  </th>
                  <td style="text-align: left !important" colspan="3">
                    {{ courseDetailInfo[0].department.name }}
                    <!-- <div
                      v-for="(semester, index) in courseDetailInfo[0].semesters"
                      :key="index"
                      class="flex"
                    >
                      {{ semester.department.name }},
                    </div> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex flex-col gap-4 px-2">
            <h2 class="text-2xl text-primary font-bold">Course Objective</h2>
            <p>{{ this.courseDetailInfo[0].short_description }}</p>
          </div>

          <div class="flex flex-col gap-4 px-2">
            <h2 class="text-2xl text-primary font-bold">Description</h2>
            <p v-html="this.courseDetailInfo[0].description"></p>
          </div>
          <!-- <div
            class="flex flex-col gap-4 px-2"
            v-if="courseDetailInfo[0].pdf_urls && courseDetailInfo[0].outcome"
          >
            <h2 class="text-2xl text-primary font-bold">
              {{ courseDetailInfo[0].outcome || "Course Progress Outline" }}
            </h2>
            <a
              v-if="courseDetailInfo[0].pdf_urls"
              :href="courseDetailInfo[0].pdf_urls"
              target="_blank"
              class="cursor-pointer"
            >
              <span class="text-gray-700 text-4xl">📄</span>
            </a>
          </div> -->
           <div
            v-if="
              courseDetailInfo[0].pdf_urls != null &&
              courseDetailInfo[0].url_list.length === 0
            "
          >
            <div
              class="flex flex-col gap-4 px-2"
              v-if="courseDetailInfo[0].pdf_urls && courseDetailInfo[0].outcome"
            >
              <h2 class="text-lg text-primary font-bold">
                {{ courseDetailInfo[0].outcome || "Course Progress Outline" }}
              </h2>

              <!-- <iframe
              v-if="this.courseDetailInfo[0].pdf_urls != null && this.courseDetailInfo[0].pdf_urls != ''"
              :src="convertHttpToHttps(this.courseDetailInfo[0].pdf_urls)"
              class="lg:h-[400px]"
            ></iframe> -->
              <a
                v-if="courseDetailInfo[0].pdf_urls"
                :href="courseDetailInfo[0].pdf_urls"
                target="_blank"
                class="cursor-pointer"
              >
                <span class="text-gray-700 text-4xl">📄</span>
              </a>
            </div>
          </div>
       <div
  v-if="courseDetailInfo[0].url_list.length > 0 && courseDetailInfo[0].outcome"
  class="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden"
>
  <!-- Header -->
  <div class="bg-gradient-to-r from-blue-600 to-cyan-500 px-6 py-5 text-white">
    <div class="flex items-center gap-3">
      <div class="bg-white/20 p-2 rounded-xl">
        <svg
          class="w-6 h-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      </div>

      <div>
        <h2 class="text-lg sm:text-base font-bold">
          {{ courseDetailInfo[0].outcome || "Course Progress Outline" }}
        </h2>
        <p class="text-blue-100 text-xs sm:text-[11px]">
          Course Resources & Documents
        </p>
      </div>
    </div>
  </div>

  <!-- Documents -->
  <div class="p-6">
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <a
        v-for="(pdf, index) in courseDetailInfo[0].url_list"
        :key="pdf.id"
        :href="pdf.file_url"
        target="_blank"
        class="group bg-gray-50 hover:bg-white border border-gray-200 hover:border-blue-400 rounded-2xl p-4 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
      >
        <div class="flex items-center gap-4">
          <!-- PDF Icon -->
          <div class="w-12 h-12 rounded-xl bg-red-100 flex items-center justify-center flex-shrink-0">
            <span class="text-2xl sm:text-xl">📄</span>
          </div>

          <!-- File Info -->
          <div class="flex-1 min-w-0">
            <h3
              class="font-semibold text-gray-800 truncate group-hover:text-blue-600 text-sm sm:text-xs"
            >
              {{ pdf.name || `Document ${index + 1}` }}
            </h3>

            <div class="flex items-center gap-2 mt-1 text-xs sm:text-[10px]">
              <span class="bg-red-100 text-red-600 px-2 py-1 rounded-full">PDF</span>
              <span class="text-gray-500">Resource {{ index + 1 }}</span>
            </div>
          </div>

          <!-- Arrow -->
          <svg
            class="w-5 h-5 text-gray-400 group-hover:text-blue-500 group-hover:translate-x-1 transition-all sm:w-4 sm:h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
        </div>
      </a>
    </div>

    <!-- Footer Stats -->
    <div class="mt-6 pt-4 border-t border-gray-100 flex items-center justify-between text-sm sm:text-xs">
      <p class="text-gray-500">
        Total Documents: <span class="font-semibold text-blue-600">{{ courseDetailInfo[0].url_list.length }}</span>
      </p>

      <div class="flex items-center gap-2 text-green-600">
        <span class="w-2 h-2 bg-green-500 rounded-full"></span>
        Available Resources
      </div>
    </div>
  </div>
</div>

          <div class="flex flex-col gap-10 px-2">
            <h2 class="text-2xl text-primary font-bold">Course Content</h2>
            <div
              class="flex flex-col gap-4"
              v-if="sectionInfo.data && sectionInfo.data.length > 0"
            >
              <div v-for="section in sectionInfo.data" :key="section">
                <div
                  class="bg-blues flex flex-col md:flex-row items-center rounded-2xl px-10 py-1 gap-5 md:justify-between cursor-pointer hover:bg-[#3aa0dd]"
                  @click="courseSectionToggle(section.id)"
                >
                  <div class="flex gap-2">
                    <div
                      v-if="section.section_participant.status == true"
                      class="flex items-center rounded-2xl py-2 gap-3 cursor-pointer"
                    >
                      <!-- <div
                        class="w-[10px] h-[10px] bg-black rounded-full"
                      ></div> -->
                      <div class="w-[16px]">
                        <img
                          src="@/assets/mdi_tick-circle-outline.png"
                          class="object-cover w-4 h-4 font-semibold"
                        />
                      </div>
                      <!-- <p
                        class="text-sm py-1"
                        :class="{
                          'text-blues font-bold': activeIndex === index,
                          'text-black': activeIndex !== index,
                        }"
                      >
                        {{ lesson.title }}
                      </p> -->
                    </div>
                    <div
                      v-else
                      class="flex items-center rounded-2xl py-2 gap-3 cursor-pointer"
                    >
                      <div class="w-[16px]">
                        <!-- <div
                          class="w-[12px] mx-auto h-[12px] rounded-full border-2"
                          :class="{
                            ' bg-blue-400 border-blue-500 border-none':
                              activeIndex === index,
                            'border-[#7c7d7f] ': activeIndex !== index,
                          }"
                        ></div> -->
                        <p v-if="section.file_type == 'video'">🎥</p>
                        <p v-if="section.file_type == 'download'">⬇️</p>
                        <p v-if="section.file_type == 'document'">📄</p>
                        <p v-if="section.file_type == 'pdf'">📕</p>
                        <p v-if="section.file_type == 'word'">📘</p>
                        <p v-if="section.file_type == 'general'">⚫</p>
                      </div>
                      <!-- <p
                        class="text-sm py-1"
                        :class="{
                          'text-blues font-bold': activeIndex === index,
                          'text-black': activeIndex !== index,
                        }"
                      >
                        {{ lesson.title }}
                      </p> -->
                    </div>

                    <p class="font-bold text-sm py-3 text-white">
                      {{ section.title }}
                    </p>
                  </div>

                  <div class="flex items-center gap-5">
                    <!-- <p
                      class="font-bold text-sm py-3 text-white flex items-center gap-4"
                      v-if="section.rbt_levels != null"
                    >
                      RBT Levels: {{ section.rbt_levels }}
                    </p> -->

                    <!-- <p
                      class="font-bold text-sm py-3 text-white"
                      v-if="section.duration != null"
                    >
                      Duration: {{ section.duration }}
                    </p> -->
                    <div class="relative group">
                      <div
                        class="relative inline-flex items-center px-3 py-1.5 text-white text-xs font-medium tracking-wide leading-snug"
                      >
                        <svg
                          :class="[
                            'w-3.5 h-3.5 mr-1.5',
                            section.is_publish
                              ? 'text-emerald-300'
                              : 'text-white',
                          ]"
                          fill="none"
                          stroke="currentColor"
                          :viewBox="
                            section.is_publish ? '0 0 24 24' : '0 0 24 24'
                          "
                          :stroke-width="section.is_publish ? '2.5' : '2'"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            :d="
                              section.is_publish
                                ? 'M5 13l4 4L19 7'
                                : 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                            "
                          ></path>
                        </svg>
                        {{ section.is_publish ? "Publish" : "UnPublish" }}
                      </div>
                    </div>

                    <p
                      class="font-medium text-sm flex items-center gap-2 py-2"
                      v-if="section.duration != null"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z"
                        />
                      </svg>
                      <span class="text-white font-bold">Duration:</span>
                      <span class="font-bold text-white">{{
                        section.duration || 0
                      }}</span>
                    </p>

                    <img
                      src="@/assets/new/upw.png"
                      v-if="activeCourseMenu == section.id"
                      style="height: 8px !important"
                      alt=""
                    />
                    <img
                      src="@/assets/new/downw.png"
                      v-if="activeCourseMenu != section.id"
                      style="height: 8px !important"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  v-for="(lesson, index) in lessonInfo.results"
                  :key="lesson"
                  v-if="activeCourseMenu == section.id"
                >
                  <div
                    class="my-5 flex flex-col gap-4"
                    v-if="section.id == lesson.section_id"
                  >
                    <div
                      v-if="lesson.section_participant.status == true"
                      class="bg-gray-200 flex flex-col md:flex-row justify-between items-center rounded-2xl px-5 md:px-10 py-2 gap-3 cursor-pointer"
                      @click="setUrlTap(lesson.video_url, index, lesson)"
                    >
                      <!-- <div
                          class="w-[10px] h-[10px] bg-black rounded-full"
                        ></div> -->
                      <div class="flex gap-2 items-center">
                        <div class="w-[16px]">
                          <img
                            src="@/assets/mdi_tick-circle-outline.png"
                            class="object-cover w-4 h-4 font-semibold"
                          />
                        </div>
                        <p
                          class="text-sm py-1"
                          :class="{
                            'text-blues font-bold': activeIndex === index,
                            'text-black': activeIndex !== index,
                          }"
                        >
                          {{ lesson.title }}
                        </p>
                      </div>

                      <p
                        class="font-medium text-sm flex items-center gap-2 py-2 text-gray-700"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-blue-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z"
                          />
                        </svg>
                        <span class="text-black">Duration:</span>
                        <span class="text-gray-900 font-semibold"
                          >{{ lesson.duration || 0 }} (min)</span
                        >
                      </p>
                    </div>
                    <div
                      v-else
                      class="bg-gray-200 flex flex-col md:flex-row justify-between items-center rounded-2xl px-10 py-2 gap-3 cursor-pointer hover:bg-gray-300"
                      @click="setUrlTap(lesson.video_url, index, lesson)"
                    >
                      <div class="flex gap-3 items-center">
                        <div class="w-[16px]">
                          <!-- <div
                          class="w-[12px] mx-auto h-[12px] rounded-full border-2"
                          :class="{
                            ' bg-blue-400 border-blue-500 border-none':
                              activeIndex === index,
                            'border-[#7c7d7f] ': activeIndex !== index,
                          }"
                        ></div> -->
                          <p v-if="lesson.file_type == 'video'">🎥</p>
                          <p v-if="lesson.file_type == 'download'">⬇️</p>
                          <p v-if="lesson.file_type == 'document'">📄</p>
                          <p v-if="lesson.file_type == 'pdf'">📕</p>
                          <p v-if="lesson.file_type == 'word'">📘</p>
                          <p v-if="lesson.file_type == 'general'">⚫</p>
                        </div>
                        <p
                          class="text-sm py-1"
                          :class="{
                            'text-blues font-bold': activeIndex === index,
                            'text-black': activeIndex !== index,
                          }"
                        >
                          {{ lesson.title }}
                        </p>
                      </div>

                      <p
                        class="font-medium text-sm flex items-center gap-2 py-2 text-gray-700"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-blue-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z"
                          />
                        </svg>
                        <span class="text-black">Duration:</span>
                        <span class="text-gray-900 font-semibold"
                          >{{ lesson.duration || 0 }} (min)</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="text-center text-gray-500 font-bold py-4 flex justify-center"
            >
              No data found
            </div>
          </div>

          <!-- <div class="flex flex-col gap-4 px-2">
            <div>
              <h1 class="text-lg font-semibold">CO PO PSO MAPPING</h1>
            </div>

            <table class="mt-6 w-full">
              <thead>
                <tr>
                  <th>CO</th>
                  <th style="text-align: left !important">
                    Course outcomes: Ability to
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in coGet" :key="i">
                  <td>{{ i.title }}</td>
                  <td style="text-align: left !important">
                    {{ i.description }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex flex-col gap-4 px-2">
            <div>
              <h1 class="text-lg font-semibold">CO PO PSO MAPPING</h1>
            </div>

            <table class="mt-6 w-full">
              <thead>
                <tr>
                  <th>CO / PO</th>
                  <th v-for="i in 12" :key="i">PO {{ i }}</th>
                  <th v-for="i in 3" :key="i">PSO {{ i }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in pso.length" :key="i">
                  <td>{{ pso[i - 1].co }}</td>
                  <td v-for="i in pso[i - 1].po_mappings" :key="i">
                    {{ i.mark }}
                  </td>
                  <td v-for="i in pso[i - 1].pso_mappings" :key="i">
                    {{ i.mark }}
                  </td>
                </tr>
              </tbody>
            </table>

            <p class="px-1 py-3 text-sm">High-3, Medium-2, Low-1</p>
          </div> -->
        </div>
        <div v-else class="flex justify-center items-center heightfix">
          No Data Found
        </div>
      </div>
    </div>

    <div class="flex" v-if="isLessonTab">
      <!-- <SideBar /> -->
      <div
        ref="sidebar"
        class="lg:flex fixed w-[80%] bg-white lg:w-[35%] xl:w-[30%] 2xl:w-[25%] lg:relative z-[60] m-4 px-5 p-10 rounded-3xl mt-3"
        :class="{ hidden: !isMobile }"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div
          v-if="courseDetailInfo"
          class="flex flex-col relative w-full h-full overflow-y-auto heighttab"
          ref="sidebarContent"
        >
          <div v-for="section in sectionInfo.data" :key="section.id">
            <div
              class="text-black flex items-center rounded-2xl px-3 py-1 gap-5 justify-between cursor-pointer"
              @click="courseSectionToggle(section.id)"
            >
              <p class="font-bold text-sm py-3 text-black">
                {{ section.title }}
              </p>
              <div class="flex gap-2 items-center">
              <div class="relative group">
  <div
    class="relative inline-flex items-center px-3 py-1.5 text-blues text-xs font-medium tracking-wide leading-snug"
  >
    <svg
      :class="['w-3.5 h-3.5 mr-1.5', section.is_publish ? 'text-emerald-600' : 'text-red-400']"
      fill="none"
      stroke="currentColor"
      :viewBox="section.is_publish ? '0 0 24 24' : '0 0 24 24'"
      :stroke-width="section.is_publish ? '2.5' : '2'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        :d="section.is_publish ? 'M5 13l4 4L19 7' : 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'"
      ></path>
    </svg>
    {{ section.is_publish ? 'Publish' : 'UnPublish' }}
  </div>
</div>
              <img
                src="@/assets/new/up.png"
                v-if="activeCourseMenu == section.id"
                style="height: 6px !important"
                alt=""
              />
              <img
                src="@/assets/new/down.png"
                v-if="activeCourseMenu != section.id"
                style="height: 6px !important"
                alt=""
              />
              </div>
            </div>

            <div
              v-for="(lesson, index) in lessonInfo.results"
              :key="lesson"
              v-if="activeCourseMenu == section.id"
            >
              <div
                class="my-1 flex flex-col gap-4"
                v-if="section.id == lesson.section_id"
              >
                <div
                  v-if="lesson.section_participant.status == true"
                  class="flex items-center rounded-2xl px-3 py-2 gap-3 cursor-pointer"
                  :ref="`lesson-${index}`"
                  @click="setUrlTap(lesson.video_url, index, lesson)"
                >
                  <div class="w-[16px]">
                    <div class="w-[18px]">
                      <img
                        src="@/assets/mdi_tick-circle-outline.png"
                        class="object-cover w-4 h-4 font-semibold"
                      />
                    </div>
                  </div>
                  <p
                    class="text-sm py-1 pl-1"
                    :class="{ 'text-blues font-bold': activeIndex === index }"
                  >
                    {{ lesson.title }}
                  </p>
                </div>

                <div
                  v-else
                  class="flex items-center rounded-2xl px-3 py-2 gap-3 cursor-pointer"
                  @click="setUrlTap(lesson.video_url, index, lesson)"
                  :ref="`lesson-${index}`"
                >
                  <div class="w-[18px]">
                    <div class="w-[16px]">
                      <div
                        class="w-[12px] mx-auto h-[12px] rounded-full border-2"
                        :class="{
                          ' bg-blue-400 border-blue-500 border-none':
                            activeIndex === index,
                          'border-gray-400 font-bold': activeIndex !== index,
                        }"
                      ></div>
                    </div>
                  </div>
                  <p
                    class="text-sm py-1 pl-1"
                    :class="{ 'text-blues font-bold': activeIndex === index }"
                  >
                    {{ lesson.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-[90%] mx-auto lg:mr-4 mt-2 lg:mt-2 rounded-3xl overflow-x-auto h-[calc(100vh-100px)]"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- laptop -->
        <div class="hidden lg:block top-0">
          <div class="flex items-center pt-10 px-10 justify-between">
            <button
              class="bg-blues text-xs text-white hover:bg-[#18469d] hover:text-white px-6 py-1.5 rounded-2xl"
              @click="isLessonTab = !this.isLessonTab"
            >
              Back
            </button>
            <!-- <pre>{{ lessonInfo.results }}</pre> -->

            <h1
              class="text-lg 2xl:text-lg font-semibold w-[50%] mx-auto text-center 2xl:w-[60%] line-clamp-3"
            >
              {{ courseDetailInfo[0].title }}
            </h1>
            <div class="flex items-center gap-10">
              <div
                class="flex items-center gap-4 cursor-pointer"
                v-if="this.activeIndex != 0"
                @click="prevCourse()"
              >
                <img src="@/assets/new/left.png" class="h-3" />
                <p class="text-base">Previous</p>
              </div>
              <div
                class="flex items-center gap-4 cursor-pointer"
                v-if="this.activeIndex != this.lessonInfo.results.length - 1"
                @click="nextCourse()"
              >
                <p class="text-base">Next</p>
                <img src="@/assets/new/right.png" class="h-3" />
              </div>
            </div>
          </div>
        </div>
        <!-- mobile -->
        <div
          class="flex flex-col gap-4 items-center pt-10 px-5 justify-between block lg:hidden"
        >
          <div class="flex flex-col gap-2 justify-between w-full">
            <div class="flex justify-end">
              <button
                class="bg-blues text-xs text-white hover:bg-[#18469d] hover:text-white px-6 py-1.5 rounded-2xl"
                @click="isLessonTab = !this.isLessonTab"
              >
                Back
              </button>
            </div>
            <h1 class="text-xl font-semibold text-wrap">
              {{ courseDetailInfo[0].title }}
            </h1>
          </div>

          <div class="flex items-center gap-10 mb-5">
            <div
              class="flex items-center gap-4 cursor-pointer"
              v-if="this.activeIndex != 0"
              @click="prevCourse()"
            >
              <img src="@/assets/new/left.png" class="h-3" />
              <p class="text-base">Previous</p>
            </div>
            <div
              class="flex items-center gap-4 cursor-pointer"
              v-if="this.activeIndex != this.lessonInfo.results.length - 1"
              @click="nextCourse()"
            >
              <p class="text-base">Next</p>
              <img src="@/assets/new/right.png" class="h-3" />
            </div>
          </div>
        </div>

        <div
          class="p-5 lg:p-10 flex flex-col gap-10 -mt-5"
          v-if="selectedlessonData"
        >
          <div class="flex flex-col gap-4 top-[10%]">
            <div class="flex items-center justify-between w-full">
              <h1 class="text-lg lg:text-lg font-semibold">
                {{ selectedlessonData.title }}
              </h1>

              <!-- <div class="flex items-center justify-end gap-10">
                <div v-if="lessonCompletedData == null">
                  <button
                    v-if="showbutton"
                    class="bg-blues text-xs text-white block px-6 py-1.5 rounded-2xl"
                    @click="
                      completeUnit(
                        selectedlessonData.section_id,
                        selectedlessonData.id
                      )
                    "
                  >
                    Complete
                  </button>
                </div>

                <div v-else>
                  <button
                    class="bg-green-700 text-white text-xs px-4 py-2 rounded-2xl"
                  >
                    Lesson Completed
                  </button>
                </div>
              </div> -->
            </div>

            <div
              class="flex items-center gap-10 -mt-3"
              v-if="selectedlessonData.lesson_or_quiz !== 'quiz' && selectedlessonData.scrom_file === null"
            >
              <div class="flex items-center rounded-2xl gap-2">
                <img src="@/assets/new/time.png" alt="" />
                <p class="text-xs">{{ selectedlessonData.duration }} min</p>
              </div>
            </div>
          </div>
           <div class="overflow-y-hidden" v-if="selectedlessonData.scrom_file">
            <iframe
              :src="selectedlessonData.scrom_file"
              class="w-full h-screen border-0"
              allowfullscreen
            ></iframe>
          </div>
          <div v-if="!selectedlessonData.scrom_file" class="overflow-y-auto -mt-10">
            <div
              v-if="
                selectedlessonData.video_url != null &&
                selectedlessonData.video_url != ''
              "
              class="md:px-5"
            >
              <iframe
                v-if="matchYoutubeUrl(selectedlessonData.video_url)"
                class="w-full lg:h-[320px] mx-auto rounded p-3"
                :src="selectedlessonData.video_url"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                @contextmenu.prevent
              >
              </iframe>

              <!-- @timeupdate="addPollsinTime" -->
              <video
                v-else
                ref="videoPlayer"
                :src="selectedlessonData.video_url"
                class="w-full lg:h-[320px] mx-auto rounded p-3"
                controls
                autoplay
                controlsList="nodownload noplaybackrate"
                disablePictureInPicture
                @play="onVideoActivity"
                @timeupdate="onVideoActivity"
                @pause="onVideoActivity"
                @contextmenu.prevent
                @dragstart.prevent
              ></video>

              <!-- <iframe
              v-if="selectedlessonData.video_url != ''"
              class="w-full h-[600px] mx-auto rounded p-3"
              :src="selectedlessonData.video_url"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            >
            </iframe> -->

              <!-- <video ref="videoPlayer" width="600" controls>
                <source :src="selectedlessonData.video_url" type="video/mp4">
                <source :src="selectedlessonData.video_url" type="video/mkv">
                Your browser does not support the video tag.
              </video> -->

              <!-- <video controls class="w-full h-[600px]">
                <source :src="selectedlessonData.video_url" type="video/mp4">
                <source :src="selectedlessonData.video_url" type="video/webm">
                <source :src="selectedlessonData.video_url" type="video/ogg">
                <source :src="selectedlessonData.video_url" type="video/ogg">
                <source :src="selectedlessonData.video_url" type="video/avi">
                <source :src="selectedlessonData.video_url" type="video/quicktime">
                <source :src="selectedlessonData.video_url" type="video/x-matroska">
                <source :src="selectedlessonData.video_url" type="video/x-flv">
              </video> -->
            </div>

            <div class="flex flex-col gap-4 md:px-5">
              <div
                v-html="selectedlessonData.content"
                class="w-full video-container"
              ></div>

              <iframe
                v-if="
                  selectedlessonData.pdf_file != null &&
                  selectedlessonData.pdf_file != ''
                "
                :src="convertHttpToHttps(selectedlessonData.pdf_file)"
                class="lg:h-[320px]"
              ></iframe>

              <!-- <p class="text-sm">{{ selectedlessonData.keyworeds }}</p> -->
              <p class="text-sm" v-if="selectedlessonData.keyworeds">
                <span class="font-semibold">Keywords:</span>
                {{ selectedlessonData.keyworeds }}
              </p>

              <audio
                controls
                v-if="
                  selectedlessonData.audio_file != null &&
                  selectedlessonData.audio_file != ''
                "
              >
                <source :src="selectedlessonData.audio_file" type="audio/ogg" />
                <source
                  :src="selectedlessonData.audio_file"
                  type="audio/mpeg"
                />
                Your browser does not support the audio element.
              </audio>

              <!-- {{ selectedlessonData.quizzes[0].quiz.id }} -->

              <!-- <div v-if="lessonCompletedData == null"> -->

              <div class="">
                <div v-if="selectedlessonData.quizzes">
                  <div v-if="selectedlessonData.quizzes != null">
                    <div v-if="selectedlessonData.quizzes[0]">
                      <div v-if="selectedlessonData.quizzes[0].quiz.id">
                        <QuizTest
                          v-if="selectedlessonData.quizzes[0].quiz.id"
                          :key="quizKey"
                          :course_id="this.course_id"
                          :quiz_id="selectedlessonData.quizzes[0].quiz.id"
                          :taker_id="selectedlessonData.course_quiz_takers_id"
                          :lesson_quiz_id="selectedlessonData.lesson_quizzes"
                          @pushLessonComplete="receiveLessonComplete"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div v-if="currentQuizDetails != null"> 
                 <p>Data check :: {{ currentQuizDetails }}  
                  <p>{{ currentQuizDetails.quiztakers_set }} {{ currentQuizDetails.qualify_certificate }} </p>             
              </div> -->

              <!-- <QuizTest
                          v-if="selectedlessonData.quizzes[0].quiz.id"
                          :key="quizKey"
                          :course_id="this.course_id"
                          :quiz_id="selectedlessonData.quizzes[0].quiz.id"
                          :taker_id="selectedlessonData.course_quiz_takers_id"
                        /> -->

              <!-- <div v-else class="flex flex-col gap-6 items-center justify-center">
                <div
                  v-if="dataval != null"
                  class="text-black font-bold p-10 rounded-2xl border text-lg"
                >
                  This Lesson Quiz is Completed.
                  <div class="flex gap-4"></div>
                </div>
  
        
  
                <div class="flex items-center gap-10">
                  <div
                    class="flex items-center gap-4 cursor-pointer"
                    v-if="this.activeIndex != 0"
                    @click="prevCourse()"
                  >
                    <img src="@/assets/new/left.png" class="h-3" />
                    <p class="text-base">Previous</p>
                  </div>
                  <div
                    class="flex items-center gap-4 cursor-pointer"
                    v-if="this.activeIndex != this.lessonInfo.results.length - 1"
                    @click="nextCourse()"
                  >
                    <p class="text-base">Next</p>
                    <img src="@/assets/new/right.png" class="h-3" />
                  </div>
                </div>
              </div> -->

              <!-- {{ selectedlessonData.course_quiz_takers_id }} Taker id:: -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Student/SideBar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import QuizTest from "@/views/Admin/QuizPreview.vue";
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";
import rightClickProtection from "@/mixins/rightClickProtection";
import { videoActivity } from "@/composables/useAutoLogout";

export default {
  mixins: [rightClickProtection],
  components: {
    SideBar,
    QuizTest,
    HodHeader,
    CoordinateHeader,
    Header,
    InstructorHeader,
  },
  data() {
    return {
      messageVal: null,
      totalmessage: null,
      studentList: "",
      selectedStudent: null,
      ChatpopUp: false,
      instructorChat: [
        {
          id: "",
          display_name: "",
        },
      ],
      sectionInfo: "",
      lessonInfo: "",
      videoLink: "",
      activeIndex: null,
      isLessonTab: false,
      selectedlessonData: null,
      courseDetailInfo: null,
      progress: 90,
      activeCourseMenu: null,
      lessonCompletedData: null,
      showbutton: false,
      dataval: "",
      percentage: [],
      // new
      quiz_details: [],
      currentQuizDetails: null,
      pso: [],
      coGet: [],
      loading: true,
      isLessonLoading: true,
      iframeInterval: null,
    };
  },

  props: ["course_id"],
  mounted() {
    this.iframeInterval = setInterval(() => {
      videoActivity();
    }, 10000);
  },

  beforeUnmount() {
    clearInterval(this.iframeInterval);
  },
  async created() {
    this.detailsgets();
    this.progressget();
    this.getPSO();

    await axios
      .get(
        `${process.env.VUE_APP_API}/co/get/${this.course_id}/?Key=${this.userInfo.token_key}`,
      )
      .then((response) => {
        this.coGet = response.data.data;
      });

    await axios
      .get(
        `${process.env.VUE_APP_API}/courses/?id=${this.course_id}&Key=${this.userInfo.token_key}`,
      )
      .then((response) => {
        if (response.data.data.data.status == 200) {
          this.courseDetailInfo = response.data.data.data.data;
          setTimeout(() => {
            this.loading = false;
          }, 100);
        } else {
          this.loading = false;
          console.error(
            "Failed to load course:",
            resData.message || "Unknown error",
          );
        }
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });

    await axios
      .get(
        `${process.env.VUE_APP_API}/coursesdata/${this.course_id}/?Key=${this.userInfo.token_key}`,
      )
      .then((response) => {
        this.instructorChat[0].id = response.data.user_id;
      });
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    onVideoActivity() {
      videoActivity();
    },
    fixUrl(url) {
      if (!url) return "";
      const match = url.match(/https:\/\/.*\.mp4/);
      return match ? match[0] : url;
    },

    matchYoutubeUrl(url) {
      var p =
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      if (url.match(p)) {
        // return url.match(p)[1];
        return true;
      }
      return false;
    },

    async getPSO() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/pso/get/${this.course_id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.pso = response.data.data;
          } else {
            console.log("got error");
          }
        });
    },

    async quizPreview(id) {
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${id}/?Key=${token}`,
        )
        .then((response) => {
          this.dataval = response.data.data;
        });
    },

    convertHttpToHttps(url) {
      if (url.startsWith("http://")) {
        return url.replace("http://", "https://");
      }
      return url;
    },

    async getCompletedLesson(unit_id, lesson_id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/completed-lesson-tracking/${this.userInfo.user.id}/${lesson_id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.lessonCompletedData = "";
          } else {
            console.log("Something went wrong::");
          }
        });
    },

    receiveLessonComplete() {
      this.completeUnit(
        this.selectedlessonData.section_id,
        this.selectedlessonData.id,
      );
    },

    async completeUnitStart(unit_id, lesson_id) {
      await axios
        .post(
          `${process.env.VUE_APP_API}/lesson-tracking/${this.userInfo.user.id}/${unit_id}/${lesson_id}/?Key=${this.userInfo.token_key}`,
          {},
        )
        .then((response) => {
          if (response) {
            this.getCompletedLesson(unit_id, lesson_id);
            this.detailsgets();
            this.progressget();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async completeUnit(unit_id, lesson_id) {
      await axios
        .post(
          `${process.env.VUE_APP_API}/lesson-tracking/${this.userInfo.user.id}/${unit_id}/${lesson_id}/?Key=${this.userInfo.token_key}&status=true`,
          {},
        )
        .then((response) => {
          if (response) {
            this.getCompletedLesson(unit_id, lesson_id);
            this.detailsgets();
            this.progressget();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    courseSectionToggle(id) {
      if (this.activeCourseMenu == id) {
        this.activeCourseMenu = null;
      } else {
        this.activeCourseMenu = id;
      }
    },
    prevCourse() {
      this.showbutton = false;
      this.lessonCompletedData = null;
      this.selectedlessonData = null;
      this.quizKey++;
      if (this.activeIndex > 0) {
        this.activeIndex = this.activeIndex - 1;
        this.selectedlessonData = this.lessonInfo.results[this.activeIndex];
        this.videoLink = this.lessonInfo.results[this.activeIndex].video_url;
        this.setActiveSection();
        this.ensureSectionExpanded();
        this.scrollToActiveLesson();
      }
      this.getCompletedLesson(
        this.selectedlessonData.section_id,
        this.selectedlessonData.id,
      );
      if (this.selectedlessonData.section_participant.status == null) {
        this.completeUnitStart(
          this.selectedlessonData.section_id,
          this.selectedlessonData.id,
        );
      }
      setTimeout(() => {
        this.showbutton = true;
      }, 16000);
      this.getQuizDataList();
    },

    getQuizDataList() {},

    nextCourse() {
      this.showbutton = false;
      this.lessonCompletedData = null;
      this.selectedlessonData = null;
      this.quizKey++;
      if (this.activeIndex < this.lessonInfo.results.length - 1) {
        this.activeIndex = this.activeIndex + 1;
        this.selectedlessonData = this.lessonInfo.results[this.activeIndex];
        this.videoLink = this.lessonInfo.results[this.activeIndex].video_url;
        this.setActiveSection();
        this.ensureSectionExpanded();
        this.scrollToActiveLesson();
      }
      this.getCompletedLesson(
        this.selectedlessonData.section_id,
        this.selectedlessonData.id,
      );
      if (this.selectedlessonData.section_participant.status == null) {
        this.completeUnitStart(
          this.selectedlessonData.section_id,
          this.selectedlessonData.id,
        );
      }
      setTimeout(() => {
        this.showbutton = true;
      }, 16000);
      this.getQuizDataList();
    },
    // automatic scroll
    scrollToActiveLesson() {
      this.$nextTick(() => {
        const activeElement = this.$refs[`lesson-${this.activeIndex}`];
        const sidebarContent = this.$refs.sidebarContent;

        if (activeElement && activeElement[0] && sidebarContent) {
          const elementTop = activeElement[0].offsetTop;
          const elementHeight = activeElement[0].offsetHeight;
          const containerHeight = sidebarContent.clientHeight;
          const containerScrollTop = sidebarContent.scrollTop;

          const desiredScrollTop =
            elementTop - containerHeight / 2 + elementHeight / 2;

          sidebarContent.scrollTo({
            top: Math.max(0, desiredScrollTop),
            behavior: "smooth",
          });
        }
      });
    },
    // automatic scroll
    ensureSectionExpanded() {
      if (
        this.activeIndex >= 0 &&
        this.activeIndex < this.lessonInfo.results.length
      ) {
        const activeLesson = this.lessonInfo.results[this.activeIndex];
        if (activeLesson && activeLesson.section_id) {
          if (this.activeCourseMenu !== activeLesson.section_id) {
            this.activeCourseMenu = activeLesson.section_id;

            this.$nextTick(() => {
              setTimeout(() => {
                this.scrollToActiveLesson();
              }, 300);
            });
          }
        }
      }
    },

    setUrlTap(url, index, lesson) {
      this.activeIndex = index;
      this.selectedlessonData = lesson;
      this.showbutton = false;
      this.selectedlessonData = null;
      this.lessonCompletedData = null;
      this.quizKey++;
      this.isLessonTab = true;
      this.videoLink = url;
      this.activeIndex = index;
      this.selectedlessonData = lesson;
      this.setActiveSection();
      if (this.selectedlessonData.section_participant.status == null) {
        this.completeUnitStart(lesson.section_id, lesson.id);
      }
      if (this.selectedlessonData.section_participant.status == false) {
        this.completeUnitStart(lesson.section_id, lesson.id);
      }
      // this.completeUnitStart(lesson.section_id, lesson.id);
      this.getCompletedLesson(lesson.section_id, lesson.id);

      setTimeout(() => {
        this.showbutton = true;
      }, 16000);
      this.getQuizDataList();
      this.scrollToActiveLesson();
    },

    setUrl(url, index, lesson) {
      this.showbutton = false;
      this.selectedlessonData = null;
      this.lessonCompletedData = null;
      this.quizKey++;
      this.videoLink = url;
      this.activeIndex = index;
      this.selectedlessonData = lesson;
      this.setActiveSection();
      // this.completeUnitStart(lesson.section_id, lesson.id);
      if (this.selectedlessonData.section_participant.status == null) {
        this.completeUnitStart(lesson.section_id, lesson.id);
      }
      this.getCompletedLesson(lesson.section_id, lesson.id);
      setTimeout(() => {
        this.showbutton = true;
      }, 16000);
      this.getQuizDataList();
    },

    setActiveSection() {
      const activeSection =
        this.lessonInfo.results[this.activeIndex].section_id;
      this.activeCourseMenu = activeSection;
    },

    async detailsgets() {
      this.isLessonLoading = true;

      try {
        const sectionRes = await axios.get(
          `${process.env.VUE_APP_API}/section/?course_name=${this.course_id}&Key=${this.userInfo.token_key}`,
        );
        this.sectionInfo = sectionRes.data;

        const lessonRes = await axios.get(
          `${process.env.VUE_APP_API}/lessons/?Key=${this.userInfo.token_key}&course_name=${this.course_id}`,
        );
        this.lessonInfo = lessonRes.data;

        if (this.lessonInfo && this.lessonInfo.count) {
          this.lessonCount = this.lessonInfo.count;
        } else {
          this.lessonCount = 0;
        }
      } catch (error) {
        console.error("Error fetching lessons:", error);
        this.lessonCount = 0;
      } finally {
        this.isLessonLoading = false;
      }
    },
    async progressget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/user-course-list-lesson-percentage/?id=${this.course_id}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.data) {
            this.percentage = response.data.data[0];
          }
        });
    },
  },
};
</script>

<style scoped>
td,
thead,
tr,
th {
  text-align: center;
  padding: 10px 20px;
  border: 1px solid black !important;
}
.heighttab {
  height: calc(100vh - 250px) !important;
}
.heightfix {
  height: calc(100vh - 170px) !important;
}
.heightfixed {
  height: calc(100vh - 460px) !important;
}
:deep(.video-container iframe) {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16 / 9;
  max-height: 500px;
}
.heighttab {
  scroll-behavior: smooth;
}

.active-lesson {
  background-color: #f0f8ff;
  border-left: 3px solid #007bff;
}
</style>
